/**
 * Clamps a quantity value to be at least the given minimum (default 1).
 * Use this to guard against CL.Quantity emitting values below minValue
 * (e.g. when the user clears the text input).
 */
export const clampQuantity = (quantity: number, min = 1): number =>
  Number.isFinite(quantity) ? Math.max(min, quantity) : min;
